import { Component, Input } from '@angular/core';
import { CompanyAdditionalIncome } from '@app/models/payroll/company-additional-income.model';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-edit-company-additional-income',
    templateUrl: './edit-company-additional-income.template.html',
})
export class EditCompanyAdditionalIncomeForm extends BaseForm {
    @Input() allCompanyAdditionalIncomes: CompanyAdditionalIncome[] = [];
    editMode = false;
    companyAdditionalIncome: CompanyAdditionalIncome | null = null;
    isReseting = false;

    startEditMode(companyAdditionalIncome: CompanyAdditionalIncome): void {
        this.reset();
        this.companyAdditionalIncome = companyAdditionalIncome;
        this.editMode = true;
    }

    reset(): void {
        this.editMode = false;
        this.companyAdditionalIncome = null;
        this.allCompanyAdditionalIncomes.forEach((companyAdditionalIncome) => companyAdditionalIncome.revert());
        this.isReseting = true;
        setTimeout(() => {
            this.isReseting = false;
        }, 0);
    }

    refresh(): void {}
}
